import React, { useState, useEffect } from 'react';
import { filmsAPI } from '../services/api';

const Films = () => {
  const [films, setFilms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    loadFilms();
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const checkMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  const loadFilms = async () => {
    try {
      const response = await filmsAPI.getAll();
      setFilms(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error loading films:', error);
      setLoading(false);
    }
  };

  const getYouTubeId = (url) => {
    const regex = /(?:youtube\.com\/.*[?&]v=|youtu\.be\/)([^"&?/\s]{11})/;
    const match = url.match(regex);
    return match ? match[1] : null;
  };

  if (loading) return <div style={styles.loading}>Cargando...</div>;

  return (
    <section style={isMobile ? {...styles.section, ...styles.sectionMobile} : styles.section}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h2 style={isMobile ? {...styles.title, ...styles.titleMobile} : styles.title}>FILMS</h2>
        </div>
        <div>
          <img style={styles.img} src="/images/films/IMAGE-FILMS.jpg" alt="films" />
        </div>
        <div style={styles.buttonContainer}>
          <a 
            target='_blank' 
            href="https://www.youtube.com/@PanteraMG.Official"
            style={isMobile ? {...styles.youtubeButton, ...styles.youtubeButtonMobile} : styles.youtubeButton}
          >
            @PanteraMG.Official
          </a>
        </div>
        <div style={isMobile ? {...styles.grid, ...styles.gridMobile} : styles.grid}>
          {films.map(film => {
            const videoId = getYouTubeId(film.youtubeUrl);
            
            return (
              <div key={film.id} style={styles.card}>
                <div style={styles.videoContainer}>
                  {videoId ? (
                    <iframe
                      width="100%"
                      height="100%"
                      src={`https://www.youtube.com/embed/${videoId}`}
                      title={film.title}
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      style={styles.iframe}
                    ></iframe>
                  ) : (
                    <div style={styles.noVideo}>Video not available</div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    minHeight: '100vh',
    background: '#000',
    padding: '100px 2rem 4rem',
    fontFamily: 'Roboto, sans-serif',
  },
  sectionMobile: {
    padding: '80px 1rem 2rem',
  },
  container: {
    maxWidth: '1200px',
    margin: '0 auto',
    fontFamily: 'Roboto, sans-serif',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '3rem',
    fontFamily: 'Roboto, sans-serif',
  },
  title: {
    fontSize: '3rem',
    color: '#fff',
    letterSpacing: '0.3rem',
    fontFamily: 'Roboto, sans-serif',
  },
  titleMobile: {
    fontSize: '2rem',
    letterSpacing: '0.15rem',
  },
  img:{
    width: '100%',
    marginBottom: '3rem',
    fontFamily: 'Roboto, sans-serif',
  },
  buttonContainer:{
    textAlign: 'center',
    marginBottom: '3rem',
    fontFamily: 'Roboto, sans-serif',
  },
  youtubeButton: {
    display: 'inline-block',
    padding: '0.75rem 2rem',
    background: '#1a1a1a',
    color: '#fff',
    textDecoration: 'none',
    borderRadius: '5px',
    fontSize: '1rem',
    letterSpacing: '0.05rem',
    transition: 'all 0.3s ease',
    border: '1px solid #333',
    fontFamily: 'Roboto, sans-serif',
  },
  youtubeButtonMobile: {
    padding: '0.6rem 1.5rem',
    fontSize: '0.9rem',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem',
    fontFamily: 'Roboto, sans-serif',
  },
  gridMobile: {
    gridTemplateColumns: '1fr',
    gap: '1.5rem',
  },
  card: {
    background: '#000',
    borderRadius: '10px',
    overflow: 'hidden',
    fontFamily: 'Roboto, sans-serif',
  },
  videoContainer: {
    position: 'relative',
    width: '100%',
    paddingBottom: '56.25%',
    background: '#000',
    fontFamily: 'Roboto, sans-serif',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    fontFamily: 'Roboto, sans-serif',
  },
  noVideo: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#666',
    fontFamily: 'Roboto, sans-serif',
  },
  loading: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#fff',
    fontSize: '1.5rem',
    fontFamily: 'Roboto, sans-serif',
  },
};

export default Films;